import ApiProcessor from '@lib/processors/api-processor'

const TABLE_FILTERS = []

const TABLE_COLUMNS = [
  {
    name: 'createdAt',
    label: 'Date Created',
    icon: 'el-icon-date',
    format: 'dateTime',
    width: 120,
  },
  {
    name: 'name',
    icon: 'el-icon-document',
    width: 120,
  },
  {
    name: 'updatedAt',
    label: 'Last Updated',
    icon: 'el-icon-date',
    format: 'dateTime',
    width: 120,
  },
  {
    name: 'active',
    label: 'Status',
    icon: 'el-icon-document',
    format: v => v ? 'Active' : 'Inactive',
    width: 120,
    component: {
      props: {
        styleObj(v) {
          return v ? { color: '#29d737' } : { color: '#fc1e1e' }
        },
        badge(v) {
          const icon = v ? 'check' : 'close'
          return { name: `el-icon-${icon}`, pos: 'left' }
        },
      },
    },
  },
]

export default component => {
  return {
    processor: new ApiProcessor({
      component,
      path: 'api-keys',
      initialDataQuery: { pageSize: 25 },
    },),
    filters: TABLE_FILTERS,
    columns: TABLE_COLUMNS,
    tableName: 'api-keys',
  }
}
